import { Observable } from 'rxjs';
import { TopServiceModel } from '../../../store/self-diagnostic/top-service/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractTopServiceApiService {
  public abstract getAll(): Observable<InteractorResponse<TopServiceModel[]>>;
  public abstract upPriority(entity: TopServiceModel): Observable<InteractorResponse<TopServiceModel>>;
  public abstract downPriority(entity: TopServiceModel): Observable<InteractorResponse<TopServiceModel>>;
  public abstract save(entity: TopServiceModel): Observable<InteractorResponse<TopServiceModel>>;
  public abstract delete(id: number): Observable<InteractorResponse<TopServiceModel>>;
  public abstract sync(): Observable<InteractorResponse<TopServiceModel[]>>;
}
